import { render, staticRenderFns } from "./DeleteAccountSuccess.vue?vue&type=template&id=2e527c2b&scoped=true&"
import script from "./DeleteAccountSuccess.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccountSuccess.vue?vue&type=style&index=0&id=2e527c2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e527c2b",
  null
  
)

export default component.exports